export default __webpack_public_path__ + "static/media/480_dummy2016-schauspieler01-de.616169cd.png";